<template>
  <div class="row reverse-mobile justify-content-center">
    <UserMenu></UserMenu>

    <div class="col-12 col-md-9 center-content">
      <CommunityCard class="p-4">
        <h3 class="text-inherit">Provision Device</h3>

        <div v-if="!isOnNative" class="alert alert-secondary mt-4" role="alert">
          <p class="mb-0 d-flex align-content-center">
            <i class="material-icons mr-2 text-black">warning</i>
            To manage your licenses, please log into Community from your
            iSimulate device.
          </p>
        </div>

        <template v-if="isOnNative">
          <div
            v-if="isCurrentlyLicensed"
            class="agreement shadow rounded bg-white p-3"
          >
            <div
              class="d-flex d-flex justify-content-between align-items-center"
            >
              <h3
                class="d-flex align-items-center text-capitalize contract-title"
              >
                <i class="mr-2 material-icons text-secondary">receipt</i>
                Current License
              </h3>
              <button
                @click="relinquish()"
                class="btn btn-danger edit-button d-flex align-items-center"
              >
                <i class="material-icons mr-2">delete</i> Relinquish
              </button>
            </div>

            <strong class="d-block my-2">Details</strong>

            <div
              class="d-flex justify-content-space-between"
              v-if="!currentLicense.is_v2"
            >
              <div class="w-40">
                <ul class="list-unstyled detail-name">
                  <li class="d-flex my-1 align-items-center">
                    <i class="mr-2 material-icons text-secondary">note</i>
                    <em>Agreement ID</em>
                  </li>
                  <li class="d-flex my-1 align-items-center">
                    <i class="mr-2 material-icons text-secondary">tablet</i>
                    <em>Device ID</em>
                  </li>
                  <li class="d-flex my-1 align-items-center">
                    <i class="mr-2 material-icons text-secondary">tablet</i>
                    <em>Device Serial</em>
                  </li>
                  <li class="d-flex my-1 align-items-center">
                    <i class="mr-2 material-icons text-secondary">color_lens</i>
                    <em>Current Kit Colour</em>
                  </li>
                </ul>
              </div>
              <div class="w-60 mx-4">
                <ul class="list-unstyled text-capitalize detail-value">
                  <li class="my-1">
                    <em>{{ currentLicense.license_contract_id }}</em>
                  </li>
                  <li class="my-1">
                    <em>{{ currentLicense.device_id || "&nbsp;" }}</em>
                  </li>
                  <li class="my-1">
                    <em>{{ currentLicense.device_serial || "&nbsp;" }}</em>
                  </li>
                  <li
                    class="shadow rounded license-colour"
                    v-bind:class="
                      'kit-' + (currentLicense.license_colour || 'none')
                    "
                  ></li>
                </ul>
              </div>
            </div>

            <div v-else class="d-flex justify-content-space-between">
              <div class="w-40">
                <ul class="list-unstyled detail-name">
                  <li class="d-flex my-1 align-items-center">
                    <i class="mr-2 material-icons text-secondary">note</i>
                    <em>Label</em>
                  </li>
                  <li class="d-flex my-1 align-items-center">
                    <i class="mr-2 material-icons text-secondary">tablet</i>
                    <em>Device ID</em>
                  </li>
                  <li class="d-flex my-1 align-items-center">
                    <i class="mr-2 material-icons text-secondary">tablet</i>
                    <em>Device Serial</em>
                  </li>
                  <li class="d-flex my-1 align-items-center">
                    <i class="mr-2 material-icons text-secondary">date_range</i>
                    <em>Expires:</em>
                  </li>
                  <li class="d-flex my-1 align-items-center">
                    <i class="mr-2 material-icons text-secondary">color_lens</i>
                    <em>Current Kit Colour</em>
                  </li>
                </ul>
              </div>
              <div class="w-60 mx-4">
                <ul class="list-unstyled text-capitalize detail-value">
                  <li class="my-1">
                    <em>{{ currentLicense.description }}</em>
                  </li>
                  <li class="my-1">
                    <em>{{ currentLicense.device_id || "&nbsp;" }}</em>
                  </li>
                  <li class="my-1">
                    <em>{{ currentLicense.device_serial || "&nbsp;" }}</em>
                  </li>
                  <li class="my-1">
                    <em>{{
                      currentLicense.expiry_date
                        ? formatDate(currentLicense.expiry_date)
                        : "Never"
                    }}</em>
                  </li>
                  <li
                    class="shadow rounded license-colour"
                    v-bind:class="
                      'kit-' + (currentLicense.license_colour || 'none')
                    "
                  ></li>
                </ul>
              </div>
            </div>

            <strong class="d-block my-2 modules">Modules Included</strong>
            <ul
              v-if="
                currentLicense.product_modules &&
                currentLicense.product_modules.length > 0
              "
              class="w-100 d-flex flex-wrap list-unstyled"
            >
              <li
                v-bind:key="module.id"
                v-for="module in currentLicense.product_modules"
                class="my-1 mr-1 position-relative"
              >
                <button class="btn btn-sm btn-primary">
                  {{ module.name }}
                </button>
              </li>
            </ul>
            <em v-else>
              We couldn't find any modules included on this licences agreement
            </em>
          </div>

          <h5 class="my-4">Your Standalone Licenses</h5>

          <div
            v-for="v2License in v2Licenses"
            :key="v2License.uuid_id"
            class="agreement shadow rounded bg-white p-3"
          >
            <div
              class="licensed-alert alert alert-info w-100 mt-4"
              v-show="v2License.uuid_id === currentLicense.uuid_id"
            >
              <em class="font-weight-bold"> This is your current license </em>
            </div>

            <div
              class="d-flex d-flex justify-content-between align-items-center"
            >
              <h3
                class="d-flex align-items-center text-capitalize contract-title"
              >
                <i class="mr-2 material-icons text-secondary">note</i>
                {{ v2License.product.name }} License
              </h3>

              <div
                v-if="
                  !isCurrentlyLicensed &&
                  isOnNative &&
                  deviceInfo.product === v2License.product.key_name
                "
                @click="goClaimV2(v2License)"
              >
                <button class="btn btn-success d-flex align-items-center">
                  <i class="material-icons mr-2">note_add</i> Claim
                </button>
              </div>
              <button
                disabled
                v-else
                class="btn btn-success d-flex align-items-center"
              >
                <i class="material-icons mr-2">block</i> Unavailable
              </button>
            </div>

            <strong class="d-block my-2">Details</strong>
            <div class="d-flex justify-content-space-between">
              <div class="w-40">
                <ul class="list-unstyled detail-name">
                  <li class="d-flex my-1 align-items-center">
                    <i class="mr-2 material-icons text-secondary">dvr</i>
                    <em>Label:</em>
                  </li>
                  <li class="d-flex my-1 align-items-center">
                    <i class="mr-2 material-icons text-secondary">
                      date_range
                    </i>
                    <em>Created:</em>
                  </li>
                  <li class="d-flex my-1 align-items-center">
                    <i class="mr-2 material-icons text-secondary">
                      date_range
                    </i>
                    <em>Expires:</em>
                  </li>
                  <li class="d-flex my-1 align-items-center">
                    <i class="mr-2 material-icons text-secondary"> dvr </i>
                    <em>Package:</em>
                  </li>
                </ul>
              </div>
              <div class="w-60 mx-4">
                <ul class="list-unstyled text-capitalize detail-value">
                  <li class="my-1">
                    <em>{{ v2License.description }}</em>
                  </li>
                  <li class="my-1">
                    <em>{{ formatDate(v2License.created_at) || "&nbsp;" }}</em>
                  </li>
                  <li class="my-1">
                    <em>{{
                      v2License.expiry_date
                        ? formatDate(v2License.expiry_date)
                        : "Never"
                    }}</em>
                  </li>
                  <li class="my-1">
                    <em>{{
                      v2License.base_package
                        ? v2License.base_package.name
                        : "&nbsp;"
                    }}</em>
                  </li>
                </ul>
              </div>
            </div>

            <strong class="d-block my-2 modules">Modules Included</strong>
            <ul
              v-if="v2License.product_modules.length > 0"
              class="w-100 d-flex flex-wrap list-unstyled"
            >
              <li
                v-for="module in v2License.product_modules"
                v-bind:key="module.id"
                class="my-1 mr-1 position-relative"
              >
                <button class="btn btn-sm btn-primary">
                  {{ module.name }}
                </button>
              </li>
            </ul>
            <em v-else>
              We couldn't find any modules included on this licence
            </em>
          </div>

          <h5 class="my-4">Your License Agreements</h5>

          <div
            v-bind:key="contract.id"
            v-for="contract in contracts"
            class="agreement shadow rounded bg-white"
          >
            <div
              class="licensed-alert alert alert-info w-100 mt-4"
              v-show="contract.licensedToThisContract"
            >
              <em class="font-weight-bold">
                Your device is currently licensed to this agreement
              </em>
            </div>
            <div class="p-3">
              <div
                class="d-flex d-flex justify-content-between align-items-center"
              >
                <h3
                  class="d-flex align-items-center text-capitalize contract-title"
                >
                  <i class="mr-2 material-icons text-secondary">note</i>
                  {{ contract.product.name }} License Agreement
                </h3>

                <router-link
                  v-if="
                    !contract.is_v2_converted &&
                    contract.numberOfAvaiableLicenses > 0 &&
                    !isCurrentlyLicensed &&
                    isOnNative &&
                    deviceInfo.product === contract.product.key_name
                  "
                  class
                  :to="{
                    name: 'my-claim',
                    params: { contractId: contract.id },
                  }"
                >
                  <button class="btn btn-success d-flex align-items-center">
                    <i class="material-icons mr-2">note_add</i> Claim
                  </button>
                </router-link>
                <button
                  disabled
                  v-else
                  class="btn btn-success d-flex align-items-center"
                >
                  <i class="material-icons mr-2">block</i> Unavailable
                </button>
              </div>

              <div class="my-2 licenses-left my-2">
                <strong>
                  You have
                  <em
                    :class="{
                      'text-danger': contract.numberOfAvaiableLicenses <= 0,
                    }"
                  >
                    {{ contract.numberOfAvaiableLicenses }}
                  </em>
                  licenses available on this agreement
                </strong>
              </div>

              <strong class="d-block my-2">Details</strong>
              <div class="d-flex justify-content-space-between">
                <div class="w-40">
                  <ul class="list-unstyled detail-name">
                    <li class="d-flex my-1 align-items-center">
                      <i class="mr-2 material-icons text-secondary">dvr</i>
                      <em>Type:</em>
                    </li>
                    <li class="d-flex my-1 align-items-center">
                      <i class="mr-2 material-icons text-secondary">
                        format_list_numbered
                      </i>
                      <em>Licenses on agreement</em>
                    </li>
                    <li class="d-flex my-1 align-items-center">
                      <i class="mr-2 material-icons text-secondary">
                        check_circle_outline
                      </i>
                      <em>Licenses used:</em>
                    </li>
                    <li class="d-flex my-1 align-items-center">
                      <i class="mr-2 material-icons text-secondary">
                        perm_identity
                      </i>
                      <em>Agreement ID:</em>
                    </li>
                    <li class="d-flex align-items-center">
                      <i class="mr-2 material-icons text-secondary"
                        >date_range</i
                      >
                      <em>Agreement Date:</em>
                    </li>
                  </ul>
                </div>
                <div class="w-60 mx-4">
                  <ul class="list-unstyled text-capitalize detail-value">
                    <li class="my-1">
                      <em>{{ contract.agreement_type }}</em>
                    </li>
                    <li class="my-1">
                      <em>{{ contract.number_of_licenses_allowed }}</em>
                    </li>

                    <li class="my-1">
                      <em>{{ contract.licenses.length }}</em>
                    </li>
                    <li class="my-1">
                      <em>{{ contract.id }}</em>
                    </li>
                    <li class="my-1">
                      <em>{{ contract.agreement_creation_date }}</em>
                    </li>
                  </ul>
                </div>
              </div>
              <strong class="d-block my-2 modules">Modules Included</strong>
              <ul
                v-if="contract.product_modules.length > 0"
                class="w-100 d-flex flex-wrap list-unstyled"
              >
                <li
                  v-for="module in contract.product_modules"
                  v-bind:key="module.id"
                  class="my-1 mr-1 position-relative"
                >
                  <button class="btn btn-sm btn-primary">
                    {{ module.name }}
                  </button>
                </li>
              </ul>
              <em v-else>
                We couldn't find any modules included on this licence's
                agreement
              </em>
            </div>
          </div>
        </template>
      </CommunityCard>

      <Footer />
    </div>
  </div>
</template>

<script>
import UserMenu from "../components/UserMenu";
import licenseService from "../services/license.service";
import CommunityCard from "@/components/CommunityCard";
import Footer from "@/components/Footer";
import { formatContracts, formatDate } from "@/utils/license.helper";
import logger from "@/utils/logger";

export default {
  name: "MyProvisioning",
  components: {
    UserMenu,
    CommunityCard,
    Footer,
  },
  beforeMount() {
    // Only send the request if on native:
    if (this.$store.getters.getIsOnNative) {
      this.loadData();
    }
  },
  computed: {
    deviceInfo() {
      return this.$store.getters.getDeviceInfo;
    },
    isOnNative() {
      return this.$store.getters.getIsOnNative;
    },
  },
  data: function () {
    return {
      contracts: [],
      v2Licenses: [],
      currentLicense: {},
      isCurrentlyLicensed: false,
    };
  },
  methods: {
    formatDate,
    goClaimV2(license) {
      this.$store.commit("licenseClaimStore/setCurrentLicense", license);
      this.$router.push({
        name: "my-claim-licensev2",
        params: { licenseUuid: license.uuid_id },
      });
    },
    relinquish() {
      licenseService.relinquishLicense(this.currentLicense).then(() => {
        logger.log("license.relinquished", "License relinquished", { license: this.currentLicense });
        window.webkit.messageHandlers.relinquish.postMessage("");
        this.isCurrentlyLicensed = false;
        this.loadData();
      });
    },
    loadData() {
      licenseService.myV2Licenses().then((data) => {
        this.v2Licenses = data;
      });

      licenseService.myContracts().then((data) => {
        this.contracts = formatContracts(data.contracts);

        licenseService.myLicense().then((data) => {
          logger.log("license.fetched", "Got license", { data });
          this.isCurrentlyLicensed = data != null && data !== "";
          this.currentLicense = data;

          if (!this.currentLicense.is_v2) {
            this.setModulesFromContract();
          }
        });
      });
    },
    setModulesFromContract() {
      this.contracts.forEach((contract) => {
        contract.licensedToThisContract = false;
        if (contract.id === this.currentLicense.license_contract_id) {
          this.currentLicense.product_modules = contract.product_modules;
          contract.licensedToThisContract = true;
        }
      });
    },
  },
};
</script>

<style scoped>
button:disabled {
  background: grey;
  border-color: grey;
  opacity: 0.3;
}

.agreement {
  margin-bottom: 30px;
  min-height: 200px;
  overflow: hidden;
}

.container-table {
  display: table;
}

.container-table-row {
  display: table-row;
}

.container-table-cell {
  display: table-cell;
}

.detail-name em {
  color: var(--isim-light-text);
}

.detail-value em {
  font-style: normal;
}

.contract-title i {
  font-size: 40px;
}

.modules .btn {
  cursor: none;
}

.licenses-left {
  font-weight: bolder;
  text-align: left;
  color: #000000;
}

.licenses-left em {
  font-style: normal;
  font-size: 22px;
  font-weight: 600;
  text-align: left;
  color: #014a8f;
}

.licensed-alert {
  background-color: #224b8c;
  text-align: center;
  border: none;
  border-radius: 0;
}

.licensed-alert em {
  color: #ffffff;
}

.not-native em {
  color: var(--isim-light-text);
}

.not-native i {
  color: var(--isim-light-text);
}

.noColor {
  filter: grayscale();
  opacity: 0.7;
}

.license-colour {
  display: inline-block;
  height: 35px;
  width: 35px;
  position: relative;
  font-size: 14px;
  margin-right: 4px;
  font-weight: bold;
  text-transform: capitalize;
  outline: none !important;
  border-radius: 3px;
  border: 1px solid #ccc;
  background: #efefef;
}

.kit-selected {
  position: relative;
}

/* needs to match the ones in MyLicenseClaim */
.kit-none {
  background: red; /* For browsers that do not support gradients */
  background: -webkit-linear-gradient(
    left,
    #009ee6,
    #82b753,
    #ffb1e8
  ); /* For Safari 5.1 to 6.0 */
  background: -o-linear-gradient(
    right,
    #009ee6,
    #82b753,
    #ffb1e8
  ); /* For Opera 11.1 to 12.0 */
  background: -moz-linear-gradient(
    right,
    #009ee6,
    #82b753,
    #ffb1e8
  ); /* For Firefox 3.6 to 15 */
  background: linear-gradient(
    to right,
    #009ee6,
    #82b753,
    #ffb1e8
  ); /* Standard syntax (must be last) */
}

.kit-camo {
  color: white;
  background: red; /* For browsers that do not support gradients */
  background: -webkit-linear-gradient(
    left,
    #1b5e20,
    #a88049,
    #212121
  ); /* For Safari 5.1 to 6.0 */
  background: -o-linear-gradient(
    right,
    #1b5e20,
    #a88049,
    #212121
  ); /* For Opera 11.1 to 12.0 */
  background: -moz-linear-gradient(
    right,
    #1b5e20,
    #a88049,
    #212121
  ); /* For Firefox 3.6 to 15 */
  background: linear-gradient(
    to right,
    #1b5e20,
    #a88049,
    #212121
  ); /* Standard syntax (must be last) */
}

.kit-black {
  background: #222;
  color: white;
}

.kit-blue {
  background: #009ee6;
}

.kit-green {
  background: #82b753;
}

.kit-lime {
  background: #b2ff59;
}

.kit-grey {
  background: #bab4af;
}

.kit-navy {
  background: #004674;
  color: white;
}

.kit-cyan {
  background: rgb(21, 210, 210);
}

.kit-orange {
  background: #ffaa47;
}

.kit-pink {
  background: #ffb1e8;
}

.kit-purple {
  background: #53246c;
  color: white;
}

.kit-yellow {
  background: #f1e321;
}

.kit-red {
  background: #b80029;
  color: white;
}

.kit-white {
  background: #f4f4f4;
  color: black !important;
}
</style>
